import { useStaticQuery, graphql } from 'gatsby';

const flattenMultipleRatings = (multipleRatings) => {
  if (multipleRatings.length === 0) {
    return null;
  }
  if (multipleRatings.length === 1) {
    return multipleRatings[0];
  }

  const totals = multipleRatings.reduce((acc, next) => ({
    score: (acc.score || 0) + next.score,
    maximumScore: (acc.maximumScore || 0) + next.maximumScore,
    totalNumberOfReviews: (acc.totalNumberOfReviews || 0) + Number(next.totalNumberOfReviews),
    percentageRecommendation: (acc.percentageRecommendation || 0) + next.percentageRecommendation,
  }), {});

  const result = {
    score: Number((totals.score / multipleRatings.length).toFixed(1)),
    maximumScore: Number(totals.maximumScore / multipleRatings.length.toFixed(1)),
    totalNumberOfReviews: totals.totalNumberOfReviews?.toLocaleString(),
    percentageRecommendation: totals.percentageRecommendation / multipleRatings.length,
  };

  return result;
};

const useRating = ({
  siteId,
  companyId,
  ratingId,
  ratingIds,
} = {}) => {
  const { allStrapiRating } = useStaticQuery(graphql`
    query UseStrapi4RatingScoresWithPercentageRecommentdation {
      allStrapiRating {
        nodes {
          id
          score
          maximumScore
          totalNumberOfReviews
          linkToReviewsPage
          percentageRecommendation
          companies {
            id
          }
          sites {
            id
          }
        }
      }
    }
  `);

  const ratings = allStrapiRating.nodes.map((rating) => ({
    ...rating,
    totalNumberOfReviews: rating.totalNumberOfReviews?.toLocaleString(),
  }));

  if (ratingIds) {
    const multipleRatings = ratings.filter(({ id }) => ratingIds.includes(id));
    return flattenMultipleRatings(multipleRatings);
  }

  if (siteId) {
    const multipleRatings = ratings.filter(({ sites }) => sites.some(({ id }) => id === siteId));
    return flattenMultipleRatings(multipleRatings);
  }
  if (companyId) {
    return ratings.find(({ companies }) => companies.some(({ id }) => id === companyId));
  }
  if (ratingId) {
    return ratings.find(({ id }) => id === ratingId);
  }
  return ratings[0];
};

export default useRating;
